<template>
  <b-container>
    <div class="d-flex py-3">
      <base-back-to-previous-button ref="btn__previous-page" />
    </div>

    <div class="wrapper__forum d-flex flex-column justify-content-center">
      <div v-if="isFetching" class="container__loading">
        <b-spinner label="Loading..." variant="dark" />
      </div>

      <div v-else class="container__forum">
        <forum-header
          v-if="forum && learningUnitOwner"
          ref="forum__header"
          :learning-unit-id="learningUnitId"
          :forum="forum"
          :forum-owner="learningUnitOwner"
        />

        <div class="divider" />

        <b-col class="mt-3">
          <create-forum-thread
            v-if="isVisible"
            :forum="forum"
            :learning-unit="learningUnit"
            @cancel="closeEditor"
            @submit:success="onSubmitSuccess"
          />
        </b-col>

        <forum-threads
          v-if="forum && learningUnitOwner"
          ref="forumThreadList"
          :forum="forum"
          class="my-3"
        >
          <template v-slot:top-right>
            <b-col class="text-right py-3 px-0">
              <b-button
                v-if="!isVisible"
                ref="button__create-comment"
                variant="first"
                class="button__create-comment"
                @click="isVisible = !isVisible"
                >Create new comment
              </b-button>
            </b-col>
          </template>
        </forum-threads>
      </div>
    </div>
  </b-container>
</template>
<script>
import BaseBackToPreviousButton from '../../components/base-components/BaseBackToPreviousButton';
import ForumHeader from './components/ForumHeader.vue';
import ForumThreads from './components/ForumThreads.vue';
import LearningUnit from '@/models/LearningUnit';
import CreateForumThread from './components/CreateForumThread.vue';
import Forum from '@/models/Forum';
import UserRole from '@/models/UserRole';
import Learner from '@/models/Learner';

export default {
  components: {
    BaseBackToPreviousButton,
    ForumHeader,
    ForumThreads,
    CreateForumThread
  },
  data() {
    return {
      isFetching: false,
      isVisible: false
    };
  },
  computed: {
    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.query().with('learning_unit_members').find(this.learningUnitId);
    },

    forumId() {
      return Number.parseInt(this.$route.params.forumId);
    },

    forum() {
      return Forum.query().with('liked').where('id', this.forumId).first();
    },

    learningUnitOwner() {
      const ownerRole = UserRole.learningUnitOwner();

      if (this.learningUnit && this.learningUnit.learning_unit_members.length) {
        return this.learningUnit.learning_unit_members.find(
          (member) => member.user_role === ownerRole.id
        );
      }

      return null;
    }
  },
  async mounted() {
    await this.fetch();
    await this.toggleForumView();
  },
  methods: {
    async fetch() {
      try {
        this.isFetching = true;

        await Promise.all([
          LearningUnit.api().fetchByLearningUnitId(this.learningUnitId),
          Forum.api().fetchById(this.forumId)
        ]);
      } catch (error) {
        this.$toast.error('Cannot load forum, please try again');
      } finally {
        this.isFetching = false;
      }
    },

    async toggleForumView() {
      const {
        response: { data }
      } = await Learner.api().findLearnersByLearningUnitId(this.learningUnit.id, ['LEARN_VERIFY']);

      if (
        this.$currentUser.user_roles.some((role) => role.role === 'learner') &&
        data.some((learner) => learner.id === this.$currentUser.id)
      ) {
        await Forum.api().increaseForumView(this.forumId);
      }
    },

    onSubmitSuccess(newForumThread) {
      this.$refs.forumThreadList.handleNewThread(newForumThread);
      this.isVisible = false;
    },

    closeModal() {
      this.isVisible = false;
    },

    onUpdateSuccess() {
      this.isVisible = false;
    },
    closeEditor() {
      this.isVisible = false;
    }
  }
};
</script>
